import { render, staticRenderFns } from "./SCardDetailSaleMobleComp.vue?vue&type=template&id=c31e7aa6&"
import script from "./SCardDetailSaleMobleComp.vue?vue&type=script&lang=js&"
export * from "./SCardDetailSaleMobleComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports